import React from 'react';
import { Helmet } from 'react-helmet'

import './Layout.scss';

import banner_1920 from 'src/assets/images/1920/webinar_banner_1920.jpg';

const Layout: React.FC = ({ children }) => (
  <>
    <Helmet
      htmlAttributes={{ lang: 'ru' }}
      script={[{
        type: 'text/javascript',
        innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-NLZKC2X');`
      }]}
    >

      <title>Курс «Профессия UX-дизайнер»: обучение дизайну онлайн — MST</title>
      <meta name="facebook-domain-verification" content="nt2k4f5x1wszwr3ovd3lxh9tt9h8u1" />
      <meta name="description" content="Онлайн-курс по UX-дизайну: с нуля до стажера за 4 месяца. Получите возможность поработать над реальными задачами агентства и стать частью команды MST. Первые два модуля из курса — бесплатно!" />

      <meta property="og:url" content="https://campus.growheads.ru/" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Курс «Профессия UX-дизайнер»: обучение дизайну онлайн — MST" />
      <meta property="og:description" content="Онлайн-курс по UX-дизайну: с нуля до стажера за 4 месяца. Получите возможность поработать над реальными задачами агентства и стать частью команды MST. Первые два модуля из курса — бесплатно!" />
      <meta property="og:image" content={`https://campus.growheads.ru/${banner_1920}`} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="campus.growheads.ru" />
      <meta property="twitter:url" content="https://campus.growheads.ru/" />
      <meta name="twitter:title" content="Курс «Профессия UX-дизайнер»: обучение дизайну онлайн — MST" />
      <meta name="twitter:description" content="Онлайн-курс по UX-дизайну: с нуля до стажера за 4 месяца. Получите возможность поработать над реальными задачами агентства и стать частью команды MST. Первые два модуля из курса — бесплатно!" />
      <meta name="twitter:image" content={`https://campus.growheads.ru/${banner_1920}`} />
    </Helmet>
    <noscript>
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NLZKC2X"
      height="0" width="0" style={{display: "none", visibility: "hidden"}} />
    </noscript>
    <div className="layout">{children}</div>
  </>
);

export default Layout;
